/*
 * @Author: cc
 * @LastEditTime: 2022-06-15 11:40:56
 */
import { useEffect, useState } from "react";
import {
  Button,
  Upload,
  message
} from "antd";
import axios from "axios"
import { post, get } from "../../../common/fetch";
import { connect } from "react-redux";
import certImage from "../../../img/cert.png"
import initImage from "../../../img/init.png"
function CertMgr(props: {
  userInfo: any; projectType: { type: any; }; 
}) {
  const [uploadImg, setUploadImg] = useState<any>({})
  const [messageText, setMessageText] = useState("")
  const {
    projectType: { type },
  } = props;
  const upload_props = {
    showUploadList: false,
  }
  // data:(file:any)=>{
  //   let formData = new FormData();
  //   formData.append("file", file);
  //   formData.append("uploadDataType", "image");
  //   formData.append("folder", "video");
  //   return formData
  // },
  const customRequest = async (data: any) => {
    const { file } = data;
    const formData = new FormData();
    formData.append("file", file);
    formData.append("uploadDataType", "image");
    formData.append("folder", "video");
    const response: any = await axios.post(
      "/shop/api/upload/file",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    if (response.data.code === 0) {
      console.log(response.data.data);
      setUploadImg(response.data.data)
      const img = new Image();
      img.src = response.data.data.fullPathFile;
      img.onload = () => {
        const width = img.width;
        const height = img.height;
        // 在这里你可以校验图片的像素大小
        console.log(width, height)
        if (width === 295 && height === 413) {
          setMessageText("图片大小符合要求");
        } else {
          setMessageText("图片尺寸不符");
        }
      };
      // message.success("文件上传成功");
    } else {
      // message.error(response.data.msg);
    }
  }
  const uploadSuccess = (info: any) => {
    console.log(info)
  }
  const getPhoto = () => {
    // console.log(this.$store.state.user)
    get('/user/web/user/info2',{},false).then(res=>{
      if(res.code === 0){
        if(res.data.idPhotoShort){
          setUploadImg({
            shortPathFile: res.data.idPhotoShort,
            fullPathFile: res.data.idPhotoLong
          })
          const img = new Image();
          img.src =  res.data.idPhotoLong;
          img.onload = () => {
            const width = img.width;
            const height = img.height;
            // 在这里你可以校验图片的像素大小
            console.log(width, height)
            if (width === 295 && height === 413) {
              setMessageText("图片大小符合要求");
            } else {
              setMessageText("图片尺寸不符");
            }
          };
        }
      }
    })
    
  }
  const savePhoto = () => {
    if (!uploadImg.shortPathFile) {
      message.error("请上传照片")
      return
    }
    if (messageText !== "图片大小符合要求") {
      message.error("图片尺寸不符")
      return
    }
    post('/user/web/modify/user/idPhoto', {
      idPhoto: uploadImg.shortPathFile
    }, false).then((res) => {
      if (res.code === 0) {
        message.success("保存成功")
      }
    })
  }
  useEffect(()=>{
    getPhoto()
  },[])
  return (
    <div className="certMgr">
      <h5>证照管理</h5>
      <div className="upload_box">
        <div>
          <img src={certImage} alt="" />
          <p className="tc">标准证件照样式</p>
        </div>
        <div className="ml40">
          <img src={uploadImg.fullPathFile ? uploadImg.fullPathFile : initImage} alt="" />
          <p className="tc">{messageText}</p>
        </div>
        <div className='flex-column'>
          <Upload {...upload_props} customRequest={customRequest} onChange={uploadSuccess}>
            <Button type="primary">照片上传</Button>
          </Upload>
          <Button type="primary" onClick={savePhoto}>照片保存</Button>
        </div>
      </div>
      <div>
        <p>照片要求：</p>
        <p>近期彩色标准1寸，半身免冠正面证件照(尺寸25mm*35mm，像素295*413)。</p>
        <p>功能说明:</p>
        <p>1、若需要在证书中显示照片，需要先进行照片上传。上传后照片将显示在右侧，照片是否符合标准将在信息提示区显示</p>
        <p>2、仅当照片符合要求，才可以进行照片保存，若照片不符合要求，请修改后重新进行上传。</p>
        <p>免责说明:</p>
        <p>1、此照片用途仅限于证书发放的照片合成，肖像权归用户所有。</p>
        <p>2、若用户单位要求用户上传证件照以生成带照片的证书，请用户自行决定。我公司不会主动要求用户上传证件照。</p>
      </div>
    </div>
  );
}
const getProjectType = (state: {
  projectType: { type: number; activityId?: string };
}) => {
  return {
    projectType: state.projectType,
  };
};
export default connect(getProjectType)(CertMgr);
